import { Badge, Button } from '@mui/material';
import styled from '@emotion/styled';

// Utility function to format date as DD-MM-YYYY
const formatDate = (date) => {
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [day, month, year].join('-');
};

// Get today's date in DD-MM-YYYY format
const today = formatDate(new Date());
const StyledBadge = styled(Badge)(({ bg }) => ({
  '& .MuiBadge-badge': {
    top: '-1px',
    right: '3px',
    backgroundColor: bg,
    color: '#F8F8FF',
    minWidth: '90px',
    height: '30px',
    borderRadius: "4.5px",
    fontSize: '12px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 8px',
    whiteSpace: 'nowrap',
  },
}));

const StatusBadge = ({ status, type = 'reservation' }) => {
  const statusConfig = {
    reservation: {
      'Booked': { backgroundColor: "#2669EF", text: 'Booked' },
      'Checked-In': { backgroundColor: "#00B69B", text: 'Checked-In' },
      'Checked-Out': { backgroundColor: "#FF3B30", text: 'Checked-Out' },
      // Default for reservation status
      'default': { backgroundColor: "#9E9E9E", text: status }
    },
    payment: {
      "Unpaid": { backgroundColor: "#FF3B30", text: 'Unpaid' },
      'Completed': { backgroundColor: "#00B69B", text: 'Completed' },
      // Default for payment status
      'default': { backgroundColor: "#9E9E9E", text: status }
    }
  };

  // First try to find exact match for the type
  const typeConfig = statusConfig[type] || statusConfig.reservation;

  // Then try to find exact status match, fallback to default
  const config = typeConfig[status] || typeConfig['default'];

  return (
    <Button sx={{ p: 0, minWidth: 'auto', textTransform: 'none' }}>
      <StyledBadge
        badgeContent={config.text}
        bg={config.backgroundColor}
        overlap="circular"
      />
    </Button>
  );
};

export default function TableData() {
  const formReservationListRows = (data) => {
    return data.map((dt) => ({

      reservation_id: dt.reservation_id,
      guest_name: dt.guest_name,
      arrival_date: dt.arrival_date,
      departure_date: dt.departure_date,
      nights: dt.nights,
      room_type: dt.room_type,
      room_no: dt.room_no,
      adult_child: dt.adult_child,
      reservation_status: <StatusBadge status={dt.reservation_status} type="reservation" />,
      booking_date: dt.booking_date,
      booking_source: dt.booking_source,
      payment_status: <StatusBadge status={dt.payment_status} type="payment" />,
      details: { ...dt }
    }));
  };

  return {
    formReservationListRows,
    ReservationListHeader: [
      {
        id: 'reservation_id',
        label: 'Reservation ID',
        flex: 1.4,
        minWidth: '150px', // Increase this value as needed

        accessor: 'reservation_id',
        align: 'left',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'guest_name',
        label: 'Guest Name',
        flex: 2,
        accessor: 'guest_name',
        align: 'left',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'arrival_date',
        label: 'Arrival Date',
        flex: 1,
        minWidth: '150px', // Increase this value as needed

        accessor: 'arrival_date',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'departure_date',
        label: 'Departure Date',
        flex: 1.5,
        minWidth: '150px', // Increase this value as needed

        accessor: 'departure_date',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'nights',
        label: 'No. of Nights',
        flex: 0.7,
        accessor: 'nights',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'room_type',
        label: 'Room Type',
        flex: 1,
        accessor: 'room_type',
        align: 'left',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'room_no',
        label: 'Room No.',
        flex: 0.7,
        accessor: 'room_no',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'adult_child',
        label: 'Adult / Child',
        flex: 1,
        accessor: 'adult_child',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'reservation_status',
        label: 'Reservation Status',
        minWidth: '180px', // Increase this value as needed

        flex: 1.6,
        accessor: 'reservation_status',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'booking_date',
        label: 'Booking Date',
        flex: 1.2,
        minWidth: '150px', // Increase this value as needed

        accessor: 'booking_date',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'booking_source',
        label: 'Booking Source',
        minWidth: '150px', // Increase this value as needed

        flex: 1.5,
        accessor: 'booking_source',
        align: 'left',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
      {
        id: 'payment_status',
        label: 'Payment Status',
        flex: 1.5,
        minWidth: '150px', // Increase this value as needed

        accessor: 'payment_status',
        align: 'center',
        headerStyle: { backgroundColor: '#2196F3', color: 'white' }
      },
    ],
  };
}